module.exports = __webpack_public_path__ + "static/media/java.39089b93.svg";